module.exports = __webpack_public_path__ + "img/jhk.b5f8e866.png";